import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { routerActions } from 'react-router-redux';
import { UserAuthWrapper } from 'redux-auth-wrapper';

import App from '../components/App';
import HomePage from '../containers/HomePage';
import OAuthLoginPage from '../containers/OAuthLoginPage';
import AssignmentCreatePage from '../containers/AssignmentCreatePage';
import SubmissionPage from '../containers/SubmissionPage';
import AssignmentUpdatePage from '../containers/AssignmentUpdatePage';
import AssignmentUploadPage from '../containers/AssignmentUploadPage';
import AssignmentGroupsPage from '../containers/AssignmentGroupsPage';
import InstructorAssignmentGroupsPage from '../containers/InstructorAssignmentGroupsPage';
import LogoutPage from '../containers/LogoutPage';
import ProfilePage from '../containers/ProfilePage';
import ErrorPage from '../components/ErrorPage.js';
import AboutPage from '../components/AboutPage.js';
import NotFoundPage from '../components/NotFoundPage.js';
import AssignmentCopyPage from '../containers/AssignmentCopyPage';
import AssignmentCopyAllPage from '../containers/AssignmentCopyAllPage';
import EnrollmentPage from "../containers/EnrollmentPage";
import SubscriptionPage from "../containers/SubscriptionPage";
import LogPage from '../containers/LogPage';
import { INSTRUCTOR, STUDENT } from "../constants/roles";

import { requestDropboxes } from "./route_callbacks";
import SubmittedPage from "../containers/SubmittedPage";
import StudentLatestRunscriptsPage from "../containers/StudentLatestRunscriptsPage";
import InstructorLatestRunscriptsPage from "../containers/InstructorLatestRunscriptsPage";

// Redirects to /login by default
const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.auth, // how to get the user state
  predicate: (auth) => auth.isAuthenticated, // function to run against the auth state to determine if authenticated
  redirectAction: routerActions.replace, // the redux action to dispatch for redirect
  wrapperDisplayName: 'UserIsAuthenticated', // a nice name for this auth check
  allowRedirectBack : true
});

export const getRoutes = (store) => {
    return (
        <Route path="/" component={App}>
            <IndexRoute
                component={UserIsAuthenticated(HomePage)}
            />
            <Route path="login" component={OAuthLoginPage}/>

            <Route path="dropbox/:dropboxId/assignment/create"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(AssignmentCreatePage)}
            />
            <Route path="dropbox/:dropboxId/users"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(EnrollmentPage)}
            />
            <Route path="dropbox/:dropboxId/users/:userId"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(ProfilePage)}
            />
            <Route path="dropboxes/:dropboxId/users/:userId/assignments/:assignmentId"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(SubmittedPage)}
            />
            <Route path="dropbox/:dropboxId/email_notifications"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(SubscriptionPage)}
            />
            <Route path="assignment/:assignmentId/submit"
                   component={UserIsAuthenticated(SubmissionPage)}
            />
            <Route path=":dropboxName/:assignmentName"
                   component={UserIsAuthenticated(SubmissionPage)}
            />
            <Route path=":dropboxName/:assignmentName/edit"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(AssignmentUpdatePage)}
            />
            <Route path=":dropboxName/:assignmentName/upload"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(AssignmentUploadPage)}
            />
            <Route path=":dropboxName/:assignmentName/group"
                   component={UserIsAuthenticated(AssignmentGroupsPage)}
            />
            <Route path=":dropboxName/:assignmentName/runscripts"
                   authorize={[STUDENT, INSTRUCTOR]}
                   component={UserIsAuthenticated(StudentLatestRunscriptsPage)}
            />
            <Route path="dropboxes/:dropboxId/users/:userId/assignments/:assignmentId/runscripts"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(InstructorLatestRunscriptsPage)}
            />
            <Route path=":dropboxName/:assignmentName/groups"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(InstructorAssignmentGroupsPage)}
            />
            <Route path=":dropboxName/assignments/copy"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(AssignmentCopyAllPage)}
            />
            <Route path=":dropboxName/:assignmentName/copy"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(AssignmentCopyPage)}
            />
            <Route path="logs"
                   authorize={[INSTRUCTOR]}
                   component={UserIsAuthenticated(LogPage)}
            />
            <Route path="logout" component={LogoutPage}/>
            <Route path="profile" component={UserIsAuthenticated(ProfilePage)}/>
            <Route path="about" component={AboutPage}/>
            <Route path="error" component={ErrorPage}/>
            <Route path="*" component={NotFoundPage}/>
        </Route>
    );
};



/** WEBPACK FOOTER **
 ** ./src/routes/routes.js
 **/